import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import {
  LanguageTypeMap,
  LanguageHeaderMap,
  DEFAULT_LANG,
} from "constants/vars";
import { isBrowserEnv } from "../../app/utils/constants";
import Pfb from "../../app/server/pfb";

const SLASH = "/";
const ENV_NAME = process.env.ENV_NAME || process.env.REACT_APP_ENV || "";

export const getBaseUrl = () => {
  if (isBrowserEnv) {
    return window.origin;
  }
  let appServerSideEnv = ENV_NAME;
  // 灰度
  if (appServerSideEnv.includes("beta")) {
    return "http://pre-v1-internal-gateway.upex6.net";
  }

  // 线上
  if (appServerSideEnv.includes("online")) {
    return "http://v1-internal-gateway.upex6.net";
  }

  // 开发环境
  if (!appServerSideEnv.includes("test")) {
    appServerSideEnv = "test7";
  }

  // test
  return `http://upex-gateway.${appServerSideEnv}.cointr.tools`;
};

// 创建axios实例
const instance = axios.create({
  timeout: isBrowserEnv
    ? 30000
    : ENV_NAME.includes("online") || ENV_NAME.includes("beta")
      ? 1000
      : 5000,
  // baseURL: getBaseUrl(),
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求拦截器
instance.interceptors.request.use((config) => {
  let locale = config?.data?.locales || config?.data?.locale || DEFAULT_LANG;
  config.headers["website"] = "mix";
  config.headers["terminaltype"] = 1;
  if (process.env.REACT_APP_ENV === "beta") {
    config.headers["beta"] = "beta";
  }
  config.headers["locale"] = LanguageHeaderMap[locale];
  config.headers["language"] = LanguageHeaderMap[locale];

  if (Pfb.pfb) {
    config.headers["pfb"] = Pfb.pfb;
  }

  return config;
});

instance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => {
    // 打印错误信息，包含请求信息和错误信息
    console.log("server response error", error);
    return Promise.reject(error);
  }
);

/**
 * 创建请求实例
 * @param apiGroupName 功能组，common，user等
 * @param serviceGroup 服务组，btapi表示复用主站 api表示使用混合合约
 */
function createInstance(apiGroupName: string, serviceGroup?: string) {
  // 处理一下前缀
  let base = (serviceGroup ? `/${serviceGroup}/` : "/") + apiGroupName;

  function getFullUrl(apiName: string) {
    // 预处理完整的请求url
    let url = base + apiName;
    url = getBaseUrl() + url.replace(/\/\//g, "/");
    return url;
  }

  return {
    post<T>(apiName: string, data: object = {}, header = {}): Promise<T> {
      if (!apiName || apiName === "") {
        return Promise.reject("wrong api name!");
      }
      // 与业务无关的异常将在这里处理
      return new Promise<T>((resolve, reject) => {
        const axiosOptions: AxiosRequestConfig = {
          url: getFullUrl(apiName),
          method: "post",
          data: Object.assign(data, {
            languageType:
              LanguageTypeMap[data?.locales || data?.locale || DEFAULT_LANG],
          }),
          headers: header,
        };
        instance
          .request<T>(axiosOptions)
          .then(({ data }: AxiosResponse) => {
            resolve(data.data ? data.data : data);
          })
          .catch((e) => {
            reject(e.message);
          });
      });
    },
    get<T>(apiName: string, params: object = {}, header = {}): Promise<T> {
      if (!apiName || apiName === "") {
        return Promise.reject("wrong api name!");
      }
      // 与业务无关的异常将在这里处理
      return new Promise<T>((resolve, reject) => {
        const axiosOptions: AxiosRequestConfig = {
          url: getFullUrl(apiName),
          method: "get",
          params,
          headers: header,
        };
        instance
          .request<T>(axiosOptions)
          .then((getData: AxiosResponse<T>) => {
            resolve(getData.data?.data ? getData.data?.data : getData.data);
          })
          .catch((e) => {
            reject(e.message);
          });
      });
    },
  };
}

export default createInstance;
